<template>
 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M15 6.3C15 4.47746 13.6569 3 12 3C10.3431 3 9 4.47746 9 6.3V10.7C9 12.5225 10.3431 14 12 14C13.6569 14 15 12.5225 15 10.7V6.3Z" fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6 11C6 12.5913 6.63214 14.1174 7.75736 15.2426C8.88258 16.3679 10.4087 17 12 17C13.5913 17 15.1174 16.3679 16.2426 15.2426C17.3679 14.1174 18 12.5913 18 11" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 17V22" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18 2.7998L18.5 3.7998L19.4 3.8998L18.7 4.5998L18.9 5.5998L18 5.1998L17.1 5.5998L17.3 4.5998L16.6 3.8998L17.5 3.7998L18 2.7998Z" fill="white" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21 6L21.7143 7.42857L23 7.57143L22 8.57143L22.2857 10L21 9.42857L19.7143 10L20 8.57143L19 7.57143L20.2857 7.42857L21 6Z" fill="white" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  
</template>

<script setup>
defineProps({
  fill: {
    type: String,
    default: 'white'
  },
  stroke: {
    type: String,
    default: 'white'
  }
});
</script>
